import type { ProposePlaybookOutcomeToolOutput } from "@repo/app-types/entities/configurationAgent";
import {
  buildPlaybookProposalTool,
  buildProposalMeasurementDetail,
} from "./playbookProposalTool.js";

export const ProposePlaybookOutcomeTool =
  buildPlaybookProposalTool<ProposePlaybookOutcomeToolOutput>({
    running: "Preparing an outcome rubric change",
    failed: "preparing the outcome rubric change",
    proposalTitle: () => "Proposed outcome rubric update",
    detail: (output) => buildProposalMeasurementDetail(output.sample_size),
  });
